import axios from "axios";
import { WebAPI, IFailCallbackParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIでファイル削除が成功した場合に呼び出されます
   * @callback success
   * @param {number} status - httpステータス
   */
  success: (status: number) => void;
}

function AxiosDelete(url: string, token?: string) {
  if (token) {
    return axios.delete(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  } else {
    return axios.delete(url);
  }
}

export interface IDeleteFilesParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * ファイルID配列
   */
  fileids: string[];
}

/**
 * ファイルを削除します
 * @function deleteFiles
 * @param {IDeleteFilesParams} params - ファイル削除パラメータ
 */
export function deleteFiles(params: IDeleteFilesParams): void {
  const { authService, projectid, fileids } = params;
  if (authService) {
    const promises = fileids.map((fileid) => {
      const url = WebAPI.DELETE_DATAFILE(projectid, fileid);
      return new Promise((resolve, reject) => {
        authService.getToken({
          success: (token) => {
            AxiosDelete(url, token)
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          },
          fail: (err) => {
            reject(err);
          },
        });
      });
    });
    Promise.all(promises)
      .then(() => {
        params.success(200);
      })
      .catch((err) => {
        const { id, status } = getErrorStatus(err);
        if (status === 401) {
          deleteFilesRetry401(authService, projectid, fileids, params);
        } else {
          params.fail(id, status);
        }
      });
  } else {
    const promises = fileids.map((fileid) => {
      return AxiosDelete(WebAPI.DELETE_DATAFILE(projectid, fileid));
    });
    Promise.all(promises)
      .then(() => {
        params.success(200);
      })
      .catch((err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      });
  }
}

/**
 * ファイルを削除します
 * @function deleteFilesRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} projectid - プロジェクトID
 * @param {string[]} fileids - ファイルID配列
 * @param {ICallbackParams} params - コールバックパラメータ
 */
function deleteFilesRetry401(
  authService: AuthService,
  projectid: string,
  fileids: string[],
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      const promises = fileids.map((fileid) => {
        const url = WebAPI.DELETE_DATAFILE(projectid, fileid);
        return new Promise((resolve, reject) => {
          AxiosDelete(url, token)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promises)
        .then(() => {
          params.success(200);
        })
        .catch((err) => {
          const { id, status } = getErrorStatus(err);
          params.fail(id, status);
        });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}
